import { render, staticRenderFns } from "./ComplaintScreeningSendSummary.vue?vue&type=template&id=e2fb6160&"
import script from "./ComplaintScreeningSendSummary.vue?vue&type=script&lang=js&"
export * from "./ComplaintScreeningSendSummary.vue?vue&type=script&lang=js&"
import style0 from "./ComplaintScreeningSendSummary.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports